<template>
    <div class="card-component">
        <CauseChoice v-if="$route.path === '/login'" />
        <template v-if="$store.state.loginActiveStep === 'provide'">
            <div :class="{ 'px30': $store.state.loginActiveStep === 'provide' }">
                <h2 class="page-title text-24 text-text mb-7 tracking-tight leading-tight donation-src-txt text-left">
                    <span class="text-primary">
                        {{ $t("Provide") }}
                    </span>
                    <span class="text-content">{{ $t("a Donation Source") }}</span>
                </h2>
                <p class="text-text text-left page-subtitle tracking-normal leading-7 mb-7">
                    {{ $t(`Add your card and we'll round up your spare change to the next dollar on each transaction so
                                        you
                                        can donate to the cause you love!`)
                    }}
                </p>
                <p class="text-text text-left page-subtitle tracking-normal leading-7 mb-7">
                    {{
                            $t(
                                "Add the cards that are directly linked to the financial institution you just connected to."
                            )
                    }}
                </p>
                <button v-ripple type="button"
                    class="card-add-card flex flex-col justify-center items-center text-text leading-5 mb-7"
                    @click="addCard">
                    <span class="text-36 block mb-2">+</span><span class="text-14 block font-bold">{{
                            $t("Add Card")
                    }}</span>
                </button>
            </div>
            <!--            <p-->
            <!--                class="text-text opacity-60 text-12 tracking-normal leading-4 text-center"-->
            <!--            >-->
            <!--                {{-->
            <!--                    $t(-->
            <!--                        "When you attach or change your card, we will process a one-time, $1.00 donation to your organization to make sure the card is valid.",-->
            <!--                    )-->
            <!--                }}-->
            <!--            </p>-->
        </template>
        <AddCard v-else-if="$store.state.loginActiveStep === 'addCard'" @goNextCardProcess="goNextCardProcess">
        </AddCard>
        <AuthorizeInfo v-else-if="$store.state.loginActiveStep === 'card'" @goNextCardProcess="goNextCardProcess">
        </AuthorizeInfo>
    </div>
</template>

<script>
import AddCard from "./AddCard";
import AuthorizeInfo from "./AuthorizeInfo";
import Button from "../UI/Button";
import CardItem from "../Settings/CardItem";
import ChangeDonationPreferences from "../Settings/ChangeDonationPreferences";
import CauseChoice from "../UI/CauseChoice";
export default {
    name: "FirstCard",

    components: {
        CauseChoice,
        ChangeDonationPreferences,
        CardItem,
        Button,
        AuthorizeInfo,
        AddCard
    },

    data: function () {
        return {};
    },

    mounted() {
        this.$setState("loginShowOperationTitle", true);
    },

    methods: {
        addCard: function () {
            window.scrollTo(0, 0)
            this.$setState("loginShowOperationTitle", true);
            this.$setState("loginActiveStep", "addCard");
        },
        goNextCardProcess: function (process) {
            window.scrollTo(0, 0)
            if (process === "donation") {
                this.$setState("loginSteps", {
                    card: true,
                    cause: true,
                    donation: false,
                    finished: false,
                    signUp: true
                });
            }
            this.$setState("loginActiveStep", process);
        }
    }
};
</script>
